/**
 * Lazy load components that may not be needed on every page
 * Only loads and defines custom elements when their selectors exist in the DOM
 * 
 * @param {string} selector - CSS selector to check for element existence
 * @param {string} componentName - Name to register the custom element as
 * @param {Function} importFn - Function that returns a Promise resolving to the component module
 * @returns {Promise<void>}
 */
export async function loadComponentIfNeeded(selector, componentName, importFn) {
  if (!document.querySelector(selector)) return;
  if (customElements.get(componentName)) return;
  const component = await importFn();
  if (!customElements.get(componentName)) {
    customElements.define(componentName, component.default);
  }
}

export default loadComponentIfNeeded;
